import { useEffect, useMemo } from 'react';

import { useQuery } from '@zenbusiness/application-commons-graphql';

import useConstBusinessEntityUuid from '#client/hooks/useConstBusinessEntityUuid';
import { useLogError } from '#client/hooks/useLogError';
import useToastContext from '#client/hooks/useToastContext';
import useUnitAccountId from '#client/hooks/useUnitAccountId';
import { GET_CHECK_DEPOSIT_LIMITS_QUERY } from '#client/queries';

export default function useCheckDepositLimits() {
  const { businessEntityUuid } = useConstBusinessEntityUuid();
  const { unitAccountId } = useUnitAccountId();
  const { createCommonErrorToast } = useToastContext();

  const { error, errors, loading, data, refetch } = useQuery(GET_CHECK_DEPOSIT_LIMITS_QUERY, {
    variables: {
      params: {
        businessUuid: businessEntityUuid,
        unitAccountId
      }
    },
    skip: !unitAccountId || !businessEntityUuid,
    skipCache: true,
    noThrow: true
  });

  useLogError(errors, error);
  const remains = useMemo(() => {
    if (data) {
      const { checkDepositLimits, checkDepositTotalsDaily, checkDepositTotalsMonthly } =
        data.partnerAccountLimits;
      return {
        // check deposit
        dailyCheckDepositRemain: checkDepositLimits.daily - checkDepositTotalsDaily,
        monthlyCheckDepositRemain: checkDepositLimits.monthly - checkDepositTotalsMonthly
      };
    }
    return {};
  }, [data]);

  const limit = useMemo(() => {
    if (data) {
      return data?.partnerAccountLimits?.checkDepositLimits;
    }
    return {};
  }, [data]);

  useEffect(() => {
    if (error) {
      createCommonErrorToast({ error });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return {
    limit,
    remains,
    loading,
    error,
    refetch
  };
}
